import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {ApiService} from "../../../../service/ApiService";
import {Loader} from "../../../../components/admin/Loader";
import {BodyAreaForm} from "../../../../components/admin/equipment/BodyAreaForm";
import {bodyAreaResultType} from "../../../../types/Api/BodyAreaResultType";
import {bodyArea} from "../../../../models/bodyArea";
import {bodyAreaHydrator} from "../../../../models/hydrator/bodyAreaHydrator";
import {BoxTitle} from "../../../../components/admin/BoxTitle";

export const Edit = () => {
  const uuid: undefined|string = useParams().uuid;

  const [bodyArea, setBodyArea] = useState(undefined as undefined | bodyArea);
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    if (uuid) {
      const result = ApiService.get(`/body-area/${uuid}`) as Promise<bodyAreaResultType>;

      setLoading(true);

      result
        .then((r) => {
          setBodyArea(bodyAreaHydrator.hydrate(r));
        })
        .catch(() => {
          alert("Une erreur c'est produite.")
        })
        .finally(() => {
          setLoading(false);
        });
    }

  }, [uuid]);

  return (
    <>
      {loading && (
        <Loader/>
      )}

      {!loading && (bodyArea || !uuid) && (
        <>
          <BoxTitle title={uuid ? 'Modifier une taille' : 'Ajouter une taille'}/>
          <BodyAreaForm bodyArea={bodyArea} />
        </>
      )}
    </>
  );
}
